var map = {
	"./globish-logo.png": "3b38",
	"./globish-space-logo.png": "08ed",
	"./globish-space-logo.svg": "97ed",
	"./globish-space-logo@2x.png": "e451",
	"./globish-space-logo@3x.png": "e384",
	"./svg/icon-android.svg": "a688",
	"./svg/icon-chrome.svg": "df98",
	"./svg/icon-edge.svg": "aff6",
	"./svg/icon-iphone.svg": "0658",
	"./svg/icon-mac.svg": "f5f8",
	"./svg/icon-opera.svg": "1ce7",
	"./svg/icon-question-circle.svg": "24c0",
	"./svg/icon-safari.svg": "4f81",
	"./svg/icon-window.svg": "684b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";